import React from 'react';
import { useNavigate } from 'react-router-dom';

const LogoutScreen = () => {
    const session = sessionStorage.getItem('session') ? sessionStorage.getItem('session') : null
    const navigate = useNavigate();
    const handleLoginRedirect = () => {
        sessionStorage.removeItem('session')
        navigate('/login')
    };

    return (
        <>
        {session == 'inactive' ? 
            <div className='logout-container'>
                <h1 className='logout-message'> You have been logged out.</h1>
                <button className='logout-button' onClick={handleLoginRedirect}>Login Again</button>
            </div> : 
            <div className='logout-container'>
                <h2>Redirecting to logout...</h2>
            </div>}
        </>
    )
}

export default LogoutScreen;